import React from "react";
import { ReportForm } from "./component";

export default class ReportAcordo extends React.Component {
  render() {
    return (
      <React.Fragment>
        <ReportForm />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Relatorios/Acordo/index.js